import React, { Component } from "react";
import { connect } from "react-redux";

class RenderIfUserHas extends Component {
  render() {
    const requiredRoles = this.props.user.roles.filter(r => this.props.roles.includes(r.name));

    if (requiredRoles.length > 0) {
      return <div>{this.props.children}</div>;
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.currentUser
  };
};

export default connect(mapStateToProps)(RenderIfUserHas);  



// WEBPACK FOOTER //
// ./src/common/roles/RenderIfUserHas.js